import { FC } from 'react';
import { Avatar, Box, Typography, useTheme } from '@mui/material';
import { FaKey as KeyIcon } from 'react-icons/fa';
import ModalDialog from '../../common/components/ModalDialog';
import ButtonGroup from '../../common/components/ButtonGroup';
import { ApiKey, ApiKeyStatus } from '../types/api-key-types';
import { apiKeyTypeMap } from '../utils/api-key-utils';
import { getLocalTime } from '../utils/date-utils';

const DeleteApiKeyModal: FC<
  React.PropsWithChildren<DeleteApiKeyModalProps>
> = props => {
  const theme = useTheme();
  const { open, onClose, apiKey, onDelete, isLoading } = props;

  return (
    <ModalDialog
      modalColor={theme.palette.info.main}
      aria-label='Delete API Key'
      open={open}
      onClose={onClose}
      modalHeader='Delete API Key'>
      <Box flexGrow={1} mb={2}>
        <Typography variant='body2'>
          Are you sure you want to delete the following API Key from the
          organization ?
        </Typography>
        <Box display='flex' alignItems='center' mt={2} mb={2} padding={1}>
          <Avatar>
            <KeyIcon />
          </Avatar>
          <Box display='flex' flexDirection='column' ml={1}>
            <Typography variant='body2' color='text.primary'>
              {apiKey.name}
            </Typography>
            <Typography variant='body2' color='text.primary'>
              {apiKeyTypeMap[apiKey.apiKeyRoleType]}
            </Typography>
          </Box>
        </Box>
        {apiKey.apiKeyStatus === ApiKeyStatus.Active && (
          <Typography variant='body2' color='text.primary'>
            Note: this token is still active
          </Typography>
        )}
        {apiKey.lastUsed && (
          <Typography variant='body2' color='text.primary' marginTop={1}>
            {`token was lasted used at: ${getLocalTime(apiKey.lastUsed)}`}
          </Typography>
        )}
      </Box>
      <ButtonGroup
        onCancel={onClose}
        onClick={onDelete}
        isLoading={isLoading}
        buttonCancelLabel={'Cancel'}
        buttonCancelTooltip={'Cancel this operation'}
        buttonActionLabel={'Delete'}
        buttonActionTooltip={'Delete API Key'}
        buttonActionColor={'error'}
        isActionDisabled={false}
      />
    </ModalDialog>
  );
};

interface DeleteApiKeyModalProps {
  open: boolean;
  apiKey: ApiKey;
  onClose: () => void;
  onDelete: () => void;
  isLoading: boolean;
}

export default DeleteApiKeyModal;
